// ----------------------------- API + FRONTEND ENVIRONMENT CONNECTION CONFIGURATION

import { URL_HELPERS } from "../../../_Helpers/URL.helper";
import { OBJECT_FREEZE_HELPER } from "../../../_Helpers/ObjectFreeze.helper";


// LOCAL | TUNEL_SERVER (NGROK/CLOUDLARE) | PRODUCTION | PRODUCTION_DEV
const MODE_ENVIRONMENT = "LOCAL";

// API PREFIX + PORTS
const API_PORT = 4000;
const API_FRONTEND = 3000;
const API_PREFIX = "api/v1";

// full domain/subdomain string
const API_URL_LOCAL_HOST = "localhost";

const API_URL_HOST = "";
const API_URL_DEV_HOST = "";
const API_URL_TUNEL_SERVER = "";


// LOCAL | TUNEL_SERVER (NGROK/CLOUDLARE) | PRODUCTION | PRODUCTION_DEV
const _VERSIONS = {
    FRONTEND_VERSION: 1, BACKEND_VERSION: 1, SOCKET_VERSION: 1, STATIC_VERSION: 1, DOCS_VERSION: 1
};

const PROTOCOL = MODE_ENVIRONMENT === "LOCAL" ? "http" : "https";
const SOCKET_PROTOCOL = MODE_ENVIRONMENT === "LOCAL" ? "ws" : "wss";
const IS_PROD = MODE_ENVIRONMENT === "TUNEL_SERVER" || MODE_ENVIRONMENT === "PRODUCTION" || MODE_ENVIRONMENT === "PRODUCTION_DEV";


// HOST :: FRONTEND | BACKEND
const FRONTEND_HOST = MODE_ENVIRONMENT === "LOCAL" ? API_URL_LOCAL_HOST : MODE_ENVIRONMENT === "TUNEL_SERVER" ? "TU-FRONTEND-NGROK" : MODE_ENVIRONMENT === "PRODUCTION_DEV" ? API_URL_DEV_HOST : API_URL_HOST;
const BACKEND_HOST = MODE_ENVIRONMENT === "LOCAL" ? API_URL_LOCAL_HOST : MODE_ENVIRONMENT === "TUNEL_SERVER" ? API_URL_TUNEL_SERVER : MODE_ENVIRONMENT === "PRODUCTION_DEV" ? API_URL_DEV_HOST : API_URL_HOST;

const BACKEND_PORT = MODE_ENVIRONMENT === "LOCAL" ? API_PORT : null;
const FRONTEND_PORT = MODE_ENVIRONMENT === "LOCAL" ? API_FRONTEND : null;


// ------------------------------------------------------------------------------------------
const DOCS_URL = URL_HELPERS.BUILD_URL(PROTOCOL, BACKEND_HOST, BACKEND_PORT);
const STATIC_URL = URL_HELPERS.BUILD_URL(PROTOCOL, BACKEND_HOST, BACKEND_PORT);
const BACKEND_URL = URL_HELPERS.BUILD_URL(PROTOCOL, BACKEND_HOST, BACKEND_PORT);
const FRONTEND_URL = URL_HELPERS.BUILD_URL(PROTOCOL, FRONTEND_HOST, FRONTEND_PORT);
const SOCKET_URL = URL_HELPERS.BUILD_URL(SOCKET_PROTOCOL, BACKEND_HOST, BACKEND_PORT);


const API_URL = `${BACKEND_URL}/${API_PREFIX}`;


const _SCHEMA = {
    IS_PROD: IS_PROD, MODE_ENVIRONMENT: MODE_ENVIRONMENT,

    FRONTEND: {
        VERSION: _VERSIONS.FRONTEND_VERSION, PROTOCOL: PROTOCOL, HOST: FRONTEND_HOST, PORT: FRONTEND_PORT, URL: FRONTEND_URL
    },

    BACKEND: {
        VERSION: _VERSIONS.BACKEND_VERSION, PROTOCOL: PROTOCOL, HOST: BACKEND_HOST, PORT: BACKEND_PORT,
        PREFIX: API_PREFIX, URL: BACKEND_URL, API_URL
    },

    SOCKET: {
        VERSION: _VERSIONS.SOCKET_VERSION, PROTOCOL: SOCKET_PROTOCOL, HOST: BACKEND_HOST, PORT: BACKEND_PORT, URL: SOCKET_URL
    },

    STATIC: {
        VERSION: _VERSIONS.STATIC_VERSION, PROTOCOL: PROTOCOL, HOST: BACKEND_HOST, PORT: BACKEND_PORT, URL: STATIC_URL
    },

    DOCS: {
        VERSION: _VERSIONS.DOCS_VERSION, PROTOCOL: PROTOCOL, HOST: BACKEND_HOST, PORT: BACKEND_PORT, URL: DOCS_URL
    }
};


export const ENVIRONMENT = OBJECT_FREEZE_HELPER(_SCHEMA);